import { render, staticRenderFns } from "./ClientsList.vue?vue&type=template&id=28c5c969"
import script from "./ClientsList.vue?vue&type=script&lang=ts"
export * from "./ClientsList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports